export const useFeatureFlags = () => {
  const config = useRuntimeConfig()

  return {
    bugReport: {
      enabled: config.public.bugReportEnabled === true
    }
  }
}
